import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Profile from '@/components/Profile'
import UserNew from '@/components/UserNew'
import Calculator from '@/components/Calculator'
import Munkak from '@/components/Munkak'
import NyomdaiMunkak from '@/components/NyomdaiMunkak'
import NyomdaiMunkakNew from '@/components/NyomdaiMunkakNew'
import NyomdaiMunkakPrint from '@/components/NyomdaiMunkakPrint'
import Megmunkalasok from '@/components/Megmunkalasok'
import MegmunkalasokNew from '@/components/MegmunkalasokNew'
import Munkalap from '@/components/Munkalap'
import Cikkek from '@/components/Cikkek'
import CikkekNew from '@/components/CikkekNew'
import Anyagtipusok from '@/components/Anyagtipusok'
import AnyagtipusokNew from '@/components/AnyagtipusokNew'
import Status from '@/components/Status'
import StatusNew from '@/components/StatusNew'
import UserNewPassword from '@/components/UserNewPassword'
import { BootstrapVue } from 'bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/userNew',
      name: 'UserNew',
      component: UserNew
    },
    {
      path: '/userNewPassword',
      name: 'UserNewPassword',
      component: UserNewPassword
    },
    
    {
      path: '/munkak',
      name: 'Munkak',
      component: Munkak
    },
    {
      path: '/nyomdaimunkak',
      name: 'NyomdaiMunkak',
      component: NyomdaiMunkak
    },
    {
      path: '/nyomdaimunkaknew',
      name: 'NyomdaiMunkakNew',
      component: NyomdaiMunkakNew
    },
    {
      path: '/nyomdaimunkakprint/:id',
      name: 'NyomdaiMunkakPrint',
      component: NyomdaiMunkakPrint
    },
    {
      path: '/munkalap/:id',
      name: 'Munkalap',
      component: Munkalap
    },
    {
      path: '/cikkek',
      name: 'Cikkek',
      component: Cikkek
    },
    {
      path: '/cikkekNew',
      name: 'CikkekNew',
      component: CikkekNew
    },
    {
      path: '/megmunkalasok',
      name: 'Megmunkalasok',
      component: Megmunkalasok
    },
    {
      path: '/megmunkalasokNew',
      name: 'MegmunkalasokNew',
      component: MegmunkalasokNew
    },
    {
      path: '/status',
      name: 'Status',
      component: Status
    },
    {
      path: '/statusNew',
      name: 'StatusNew',
      component: StatusNew
    },
    {
      path: '/anyagtipusok',
      name: 'Anyagtipusok',
      component: Anyagtipusok
    },
    {
      path: '/anyagtipusokNew',
      name: 'AnyagtipusokNew',
      component: AnyagtipusokNew
    },
    {
      path: '/calculator',
      name: 'Calculator',
      component: Calculator
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js